<template>
  <div>
    <img src="@/assets/img/logo.png" alt="">
  </div>
</template>

<script>
export default {
  name: "Header",
}
</script>

<style scoped lang="scss">
div {
  width: 100%;
  height: 56px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 56px;
  box-sizing: border-box;

  img {
    display: block;
    width: 209px;
  }
}
</style>
